export default "__VITE_ASSET__f4AXy3hH__"